import { render } from "./Login.vue?vue&type=template&id=0396ea70&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=0396ea70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0396ea70"

export default script